// Estimator → background color mapping for the Executive Dashboard.
// Colors are per-person identifiers, not status indicators.
// Names must match AssignedEstimator values as stored from HubSpot.
// Edit this file to add or change colors; the dashboard picks them up automatically.

export const ESTIMATOR_COLORS = {
  "Peter Tkachenko":    { bg: "#FBE2D5", text: "#222" },
  "Tommy Krystkiewicz": { bg: "#CAEDFB", text: "#222" },
  "Gauri Ambekar":      { bg: "#DAF2D0", text: "#222" },
  "Anthony Thomas":     { bg: "#C00000", text: "#fff" },
  "Ben Porter":         { bg: "#FFFF00", text: "#222" },
};

const UNASSIGNED = { bg: "#D0D0D0", text: "#555" };

export function estimatorColor(name) {
  if (!name || !name.trim()) return UNASSIGNED;
  const exact = ESTIMATOR_COLORS[name.trim()];
  if (exact) return exact;
  // Fallback: match on last name in case HubSpot sends a shortened form
  const lower = name.trim().toLowerCase();
  for (const [key, val] of Object.entries(ESTIMATOR_COLORS)) {
    const parts = key.toLowerCase().split(" ");
    if (parts.some(p => p.length > 3 && lower.includes(p))) return val;
  }
  return UNASSIGNED;
}
